var map = {
	"./en/common.json": [
		30202,
		202
	],
	"./en/page-articles.json": [
		77946,
		946
	],
	"./en/page-career.json": [
		3284,
		284
	],
	"./en/page-project.json": [
		55234,
		234
	],
	"./en/page-projects.json": [
		81765,
		765
	],
	"./en/page-reviews.json": [
		10120,
		120
	],
	"./en/page-vacancy.json": [
		25923,
		923
	],
	"./ru/common.json": [
		64406,
		406
	],
	"./ru/page-articles.json": [
		937,
		937
	],
	"./ru/page-career.json": [
		78857,
		857
	],
	"./ru/page-project.json": [
		81522,
		522
	],
	"./ru/page-projects.json": [
		20184,
		184
	],
	"./ru/page-reviews.json": [
		23310,
		310
	],
	"./ru/page-vacancy.json": [
		84263,
		263
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 90492;
module.exports = webpackAsyncContext;